module.exports = __webpack_public_path__ + "static/img/technical local olt.21849f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/objectIcons/technical local olt.png
// module id = ./src/assets/objectIcons/technical local olt.png
// module chunks = 1